import { useState } from "react";
import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';

import { parseNumber } from "~/utils/utils";

interface ITextFieldNumber extends Omit<StandardTextFieldProps, "value" | "onChange"> {
	value: number;
	onChange: (newValue: number) => void;
	zeroAsEmpty?: boolean;
}

export default function TextFieldNumber({
	value = 0,
	onChange = () => {},
	zeroAsEmpty = false,
	...props
}: ITextFieldNumber) {
	const [state, setState] = useState(() => {
		if (zeroAsEmpty && value === 0) {
			return "";
		}

		return value.toString();
	});

	function updateValue(inputString: string) {
		if (inputString) {
			const numValue = parseNumber(inputString);

			setState(numValue.toString());
			onChange(numValue);
		} else {
			setState("");
			onChange(0);
		}
	}

	return <TextField
		size="small"
		inputProps={{
			autoComplete: "off",
		}}
		onChange={event => updateValue(event.target.value)}
		value={state}
		{ ...props }
	/>;
}
